import styled from "styled-components";
import Navbar from "../components/Nabvar";
import Footer from "../components/Footer";

export default function Layout({ children }) {
  return (
    <>
      <Container>
        <Navbar />
        <div>{children}</div>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 62px);
  padding-top: 70px;
`;
